export class ImageHelper {
  public static resizeBase64Image(base64: string, maxWidth: number, maxHeight: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        const aspectRatio = width / height;

        // Calculate new dimensions
        if (width > maxWidth || height > maxHeight) {
          if (aspectRatio > 1) {
            // landscape
            width = maxWidth;
            height = Math.round(maxWidth / aspectRatio);
          } else {
            // portrait
            height = maxHeight;
            width = Math.round(maxHeight * aspectRatio);
          }
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, width, height);

        const resizedBase64 = canvas.toDataURL('image/jpeg', 0.8); // Adjust quality if needed
        resolve(resizedBase64);
      };
      img.onerror = reject;
      img.src = base64;
    });
  }

  public static  getBase64ImageSize(base64: string): number {
    const base64String = base64.split(',')[1]; // Remove the data URL prefix
    const padding = (base64String.endsWith('==')) ? 2 : (base64String.endsWith('=')) ? 1 : 0;
    const bytes = (base64String.length * 3) / 4 - padding;
    return bytes; // Size in bytes
  }
}
